/**
 * @generated SignedSource<<a030b3a9179e2a4f076cf76141dd5a38>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type AgenticWorkerRowType = "PROJECT_BILLING_ROW" | "RETAINER_PERIOD_ROW" | "%future added value";
export type AgenticWorkerRunState = "RUNNING" | "STOPPED" | "NOTHING_FOUND" | "PRODUCED" | "FAILED" | "NOT_STARTED" | "%future added value";
export type AgenticWorkerScopeKind = "PAGE" | "ROW" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type agentRunState_run$data = {
  readonly id: string;
  readonly scopeKind: AgenticWorkerScopeKind;
  readonly scopeRowType: AgenticWorkerRowType | null;
  readonly scopeRowId: number | null;
  readonly state: AgenticWorkerRunState;
  readonly rows: ReadonlyArray<{
    readonly rowType: AgenticWorkerRowType;
    readonly rowId: number;
  }>;
  readonly " $fragmentType": "agentRunState_run";
};
export type agentRunState_run$key = {
  readonly " $data"?: agentRunState_run$data;
  readonly " $fragmentSpreads": FragmentRefs<"agentRunState_run">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "agentRunState_run",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeKind",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeRowType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scopeRowId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AgenticWorkerResultRow",
      "kind": "LinkedField",
      "name": "rows",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rowId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "AgenticWorkerRun",
  "abstractKey": null
};

(node as any).hash = "82fc37997393ea77a7aadedcc0d86df0";

export default node;
